export function getShownStatScore(jsonStatsAsync: any, shownStat: any): number {
  if (!jsonStatsAsync || !shownStat) {
    return 0;
  }

  const metadata = shownStat.unique
    ? jsonStatsAsync.numeric_metadata_unique
    : jsonStatsAsync.numeric_metadata;
  return metadata ? metadata[shownStat.marker.varname] : 0;
}
